import { request } from './repository';

const url = 'person/';


const personRepository = {
    getPersons(params) {
        return request.get(url, params);
    },
    storePerson(data) {
        if(!data.email) delete data.email;
        return request.post(url, data);
    },
    getPerson(id) {
        return request.get(url + id);
    },
    updatePerson(id, data) {
        return request.put(url + id, data);
    },
    deletePerson(id) {
        return request.delete(url + id);
    },
    changePassword(data) {
        return request.post('user/reset-password-by-email', data);
    },
    findPersonByNameOrCpf(data) {
        return request.post(url + 'findbynameorcpf', data);
    },
    getAvailableSourceServices(id) {
        return request.get(
            id ? url + id + '/available-source-services':'available-source-services'
        );
    },
    getAvailableAnonymousSourceServices(){
        return request.get('all-anonymous-source-services');
    },
    printData(type){
        return request.get('persons/print', {
            type: type
        }, {
            responseType: 'blob'
        });
    },
    changePasswordUser(data) {
        return request.post(url + 'change-password-user', data);
    },
    addAddress(id, data){
        return request.post(url + `${id}/create-address`, data)
    }
}

export default personRepository
